import React, { Component } from 'react';
import ReactMapboxGl, { Layer, ZoomControl, GeoJSONLayer } from "react-mapbox-gl";
import extent from '@turf/bbox';
import { withRouter } from "react-router-dom";
import property_sales from '../../data/december17.json';
import airbnb from '../../data/airbnb.json';
import within from '@turf/points-within-polygon';
import buffer from '@turf/buffer';
import toTitleCase from '../../utils/toTitleCase';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { 
  addSA,
  addLEA,
  addCrime,
  addAirbnb,
  addProperySales,
  addNoise
} from '../../actions';
import { csvParse } from 'd3-dsv';
import csvString from '../../data/jan18';
import { csv2geojson } from 'csv2geojson';
import distance from '@turf/distance';
import { point } from '@turf/helpers';

let propertyData = {}

csv2geojson(csvString, {
  latfield: 'latitude',
  lonfield: 'longitude',
  delimiter: ','
}, function(err, data) {
  propertyData = data;
});

//console.log(propertyData)

const accessToken = "pk.eyJ1IjoiamltaWVzIiwiYSI6ImNqNTA5NHZ6azF6bjEzMm9la2xxamI3ODAifQ.wNYFbkPiIKA2ahugbV5SFw";
const style = "mapbox://styles/jimies/cjde81rr631c52sofd19qklhy";


const MapGl = ReactMapboxGl({
  accessToken: accessToken,
  minZoom: 7,
  scrollZoom: false,
  interactive: false,
  dragPan: false,
  animate: false
});

class Map extends Component {
  constructor(props) {
    super(props);

    this.state = {
      zoom: [this.props.match.params.type === 'Locality' ? 7 : 11],
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.long !== this.props.long && nextProps.lat !== this.props.lat) return true;
    return false; 
  }

  clearRedux = () => {
    this.props.addLEA(null);
    this.props.addSA(null);
    this.props.addCrime(null);
    this.props.addProperySales(null);
    this.props.addAirbnb(null);
    this.props.addNoise(null);
  }

  componentDidUpdate() {
    this.clearRedux();
    const map = this.map.state.map;
    this.props.match.params.type !== 'Clicked' && map.jumpTo({center: [this.props.long, this.props.lat], zoom: this.props.match.params.type === 'Locality' ? 7 : 11});
    map.on('render', this.handleRender);
  }

  onStyleLoad = () => {
    this.renderFeatures();
  }

  handleRender = () => {
    if (this.map.state.map.loaded()) { 
      this.renderFeatures();
    }
  }

  renderFeatures = () => {
    const map = this.map.state.map;
    const padding = (this.map.container.clientWidth / 10);

    // Clear down filters
    map.setFilter("sa_filled", ['==', 'GUID', '']);
    map.setFilter("lea_filled", ['==', 'GUID', '']);
    map.setFilter("lea_cork_filled", ['==', 'GUID', '']);

    try {
      const centerPoint = map.project([this.props.long, this.props.lat]);
      const saFeatures = map.queryRenderedFeatures(centerPoint, {layers: ['sa']});
      const leaFeatures = map.queryRenderedFeatures(centerPoint, {layers: ['lea', 'lea-cork']});
      const crimeFeatures = map.queryRenderedFeatures(centerPoint, {layers: ['crime']});
      const noiseFeatures = map.queryRenderedFeatures(centerPoint, {layers: ['noise']});

      const sa = saFeatures[0] ? saFeatures[0] : null;
      const lea = leaFeatures[0] ? leaFeatures[0] : null;
      const crime = crimeFeatures[0] ? crimeFeatures[0] : null;
      const noise = noiseFeatures[0] ? noiseFeatures[0] : null;
     
      if (lea) {
        this.props.addLEA(lea);
      }

      if (crime) {
        this.props.addCrime(crime);
      }

      if (noise) {
        this.props.addNoise(noise);
      }
      
      if (this.props.type !== 'Locality') {
        if (sa) {
          this.props.addSA(sa);
          const bbox = extent(sa.geometry);
          map.fitBounds(bbox, {padding: { top:40, right:padding, bottom: padding, left: padding }});
          map.setFilter("sa_filled", ['==', 'GUID', sa.properties.GUID]);
          
          const turfPoint = point([this.props.long, this.props.lat]);

          // Find houses within 1km radius
          const buffered = buffer(sa, 1);
          const ptsWithin = within(propertyData, buffered);

          ptsWithin.features.forEach(el => { 
            el.properties.distance = distance(turfPoint, el.geometry); 
          });

          ptsWithin.features.sort(function(a, b) {
            if (a.properties.distance > b.properties.distance) {
              return 1;
            }
            if (a.properties.distance < b.properties.distance) {
              return -1;
            }
            // a must be equal to b
            return 0;
          });

          const airbnbWithin = within(airbnb, buffered);
          this.props.addProperySales({ptsWithin: ptsWithin, distance: 'a 1km radius'});
          this.props.addAirbnb({ptsWithin: airbnbWithin, distance: 'a 1km radius'});
        }
      } else {
        if (lea) {
          const bbox = extent(lea);
          map.fitBounds(bbox, {padding: padding});
          map.setFilter("lea_filled", ['==', 'GUID', lea.properties.GUID]);
          map.setFilter("lea_cork_filled", ['==', 'GUID', lea.properties.GUID]);
          
          // Return properties within this LEA
          const ptsWithin = within(propertyData, lea);
          this.props.addProperySales({ ptsWithin: ptsWithin, distance: toTitleCase(lea.properties.LE_ENGLISH) });

        }
      }
      
    } catch(e) {
      console.log(e);
    }
    
    map.off('render', this.handleRender);
  }

  onClick = (map, e) => {
    fetch(`//geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/reverseGeocode?f=pjson&location=${e.lngLat.lng},${e.lngLat.lat}`)
      .then((response) => response.json())
      .then((json) => {
        const address = json.address.Address;
        const lat = e.lngLat.lat;
        const long = e.lngLat.lng;
        const type = 'Clicked';

        this.props.history.push(
          {
            pathname: `/stats/${lat}/${long}/${type}`,
            search: `?address=${address}`
          }
        );
      });
  }

  render() {
    return (
        <MapGl
          ref={(e) => { this.map = e; }}
          style={style}
          maxBounds={[
            [-10.546875,51.2619148531],
            [-5.3173828125,55.5534954585]
          ]}
          containerStyle={{
            width: "100%",
            height: window.innerWidth >= 500 ? "350px" : "250px"
          }}
          zoom={this.state.zoom}
          center={[this.props.long, this.props.lat]}
          onStyleLoad={this.onStyleLoad}
          onClick={this.onClick}
          >
          
          <ZoomControl/>
        </MapGl>
    );
  }
}

function mapStateToProps(state) {
  return {
    features: state.features
  }
}

function matchDispatchToProps(dispatch){
  return bindActionCreators({
    addSA,
    addLEA,
    addCrime,
    addAirbnb,
    addProperySales,
    addNoise
  }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(withRouter(Map));



// WEBPACK FOOTER //
// ./src/components/map/index.js